/* React Context for the public "Send a Case" form.
 *
 * The form has 20+ pieces of state spread across two visually separated
 * columns. Prop-drilling that surface explodes the API of any extracted
 * component, so we centralise it in a Context. The provider lives in
 * `pages/Workflow.jsx` (which owns all the state + side-effects), and the
 * left/right column components read from `useSendCase()`.
 *
 * Performance note: re-renders happen on every keystroke. The form is small
 * enough (~one screen of inputs) that this is fine in practice; if it ever
 * becomes a bottleneck, split the context into form-state vs. file-state.
 */
import { createContext, useContext } from "react";

const SendCaseContext = createContext(null);

export const SendCaseProvider = SendCaseContext.Provider;

export function useSendCase() {
    const ctx = useContext(SendCaseContext);
    if (!ctx) throw new Error("useSendCase must be used inside <SendCaseProvider>");
    return ctx;
}
